import React, { useEffect, useState } from "react";
import imageBorder from "../../assets/images/bestsellerborder.webp";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useLocation } from "react-router-dom";



export const WhychooseFranchise = ({ HexagoneImageData, franchiseDescription }) => {

    const location = useLocation();
    const { pathname } = location;
    const pathSegments = pathname.split("/").filter(Boolean); // removes empty strings
    const dynamicCityFromURL = pathSegments.length >= 1 ? pathSegments[0] : "Surat";
    const selectedLocation = dynamicCityFromURL.toLowerCase();

    // Update storage data when location changes
    const [storageData, setStorageData] = useState({
        locationDynamic: "LOCATION_DY",
        locationReplace: selectedLocation,
    });

    useEffect(() => {
        setStorageData({
            locationDynamic: "LOCATION_DY",
            locationReplace: selectedLocation,
        });
    }, [selectedLocation]);

    return (
        <div className="home-WhyChooseebg">
            <Container className="">
                <div className="row">
                    <div className="col-12">
                        <div className="text-center saree-heading choose-heading">
                            {franchiseDescription?.title}
                        </div>
                        <div className="text-center">
                            <div dangerouslySetInnerHTML={{ __html: franchiseDescription?.description }} />
                        </div>
                        <div className="d-flex justify-content-center">
                            <img
                                src={imageBorder}
                                className="border-image"
                                alt="Border Decoration"
                                loading="lazy"
                            />
                        </div>

                        {/* For mobile view, use Swiper */}
                        <div className="d-block d-lg-none">
                            <Swiper
                                spaceBetween={30}
                                pagination={{ clickable: true }}
                                modules={[Autoplay]}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}
                                className="mySwiper"
                                breakpoints={{
                                    320: { slidesPerView: 2, spaceBetween: 10 },
                                    480: { slidesPerView: 2, spaceBetween: 10 },
                                    640: { slidesPerView: 2.5, spaceBetween: 15 },
                                    768: { slidesPerView: 3, spaceBetween: 10 },
                                    1024: { slidesPerView: 4, spaceBetween: 10 },
                                    1200: { slidesPerView: 5 },
                                    1600: { slidesPerView: 5 },
                                    2000: { slidesPerView: 6 },
                                }}
                            >
                                {HexagoneImageData.map((reason, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="text-center them-font hexagon-item px-0">
                                            <div className="image-wrapper">
                                                <img
                                                    src={reason.image}
                                                    className="img-fluid choose-imag"
                                                    data-aos="zoom-in"
                                                    alt="choose-imag"
                                                    loading="lazy"
                                                />
                                            </div>
                                            <div className="text-wrapper">
                                                <h4 className="fw-bolder hexa-title choose-title">{reason.title}</h4>
                                                <p className="hexa-des fw-semibold">
                                                    {reason.description.replaceAll(
                                                        storageData?.locationDynamic,
                                                        storageData.locationReplace.charAt(0).toUpperCase() + storageData.locationReplace.slice(1)
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                        {/* For desktop view, use regular layout */}
                        <div className="d-none d-lg-block">
                            <div className="row justify-content-center px-0">
                                {HexagoneImageData.map((reason, index) => (
                                    <div
                                        key={index}
                                        className="col-6 col-lg-2 text-center them-font hexagon-item px-0"
                                    >
                                        {index % 2 === 0 ? (
                                            <>
                                                <div className="image-wrapper">
                                                    <img
                                                        src={reason.image}
                                                        className="img-fluid"
                                                        data-aos="zoom-in"
                                                        alt={reason.title}
                                                        loading="lazy"
                                                    />
                                                </div>
                                                <div className="text-wrapper">
                                                    <h4 className="fw-bolder hexa-title">
                                                        {reason.title.replaceAll(
                                                            storageData?.locationDynamic,
                                                            storageData.locationReplace.charAt(0).toUpperCase() + storageData.locationReplace.slice(1)
                                                        )}
                                                    </h4>
                                                    <p className="hexa-des fw-semibold">
                                                        {" "}
                                                        {reason.description.replaceAll(
                                                            storageData?.locationDynamic,
                                                            storageData.locationReplace.charAt(0).toUpperCase() + storageData.locationReplace.slice(1)
                                                        )}
                                                    </p>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="text-wrapper">
                                                    <h4 className="fw-bolder hexa-title">
                                                        {reason.title.replaceAll(
                                                            storageData?.locationDynamic,
                                                            storageData.locationReplace.charAt(0).toUpperCase() + storageData.locationReplace.slice(1)
                                                        )}
                                                    </h4>
                                                    <p className="hexa-des fw-semibold mb-0">
                                                        {" "}
                                                        {reason.description.replaceAll(
                                                            storageData?.locationDynamic,
                                                            storageData.locationReplace.charAt(0).toUpperCase() + storageData.locationReplace.slice(1)
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="image-wrapper">
                                                    <img
                                                        src={reason.image}
                                                        className="img-fluid"
                                                        data-aos="zoom-in"
                                                        alt={reason.title}
                                                        loading="lazy"
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};
